'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';
import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PaginationPluto from './Pagination';
import { useEffect } from 'react';
import { useState } from 'react';
import PlutoMenu from './PlutoMenu';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';


function PlutoSupportList() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)
    useEffect(() => {
        socket.on('response_get_admin_users_support', (data) => {
            setEarnings(data.users)
            setPageNumber(Math.ceil(data.usersLength2 / 10))
            setUserProfile(data)
            canUsePagination(true)
            setRank(data.rank)
            setUserId(data.user_id)

        })
        socket.emit('getUsersSupportAdmin', {
            username_like: username,
            page,
        })
    }, [])

    return (
        <SkeletonTheme baseColor="#0d131c" highlightColor="#111923">
            <div class="modal-body" style={{ color: 'var(--text-primary)' }}>
                <div className="user-details-stats">
                    {userProfile.usersLength2 != undefined ?
                        <div className="card">
                            <p>
                                {numberWithCommas(userProfile.usersLength2)}
                            </p>
                            <p>Unresolved</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}

                </div>

                <div style={{ overflow: 'auto', margin: '0 auto', padding: '20px', marginBottom: '20px', background: 'var(--accent-1)' }}>
                    <p style={{ color: 'var(--text-primary)', fontWeight: 'bold' }}>Users</p>

                    <div style={{ fontWeight: 'bold' }}>
                        <div className="user-details-table-elements" >

                            <div style={{ minWidth: '50px' }} >(id) chat</div>
                            <div style={{ minWidth: '50px', textAlign: 'left', color: 'var(--text-primary)' }} >User ID</div>
                            <div style={{ minWidth: '100px' }}>Last Message Time</div>
                            <div style={{ minWidth: '100px', textAlign: 'right', maxWidth: '100px' }}>Action</div>
                        </div>
                    </div>

                    {earnings.map((earning, i) => {
                        return (
                            <div key={earning.id} className="user-details-table-elements admin-a" style={{ color: 'var(--text-primary)', border: earning.locked_for == userId ? '1px solid yellow' : '' }}>

                                <div style={{ minWidth: '50px' }} > {earning.id || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '50px', textAlign: 'left', color: 'var(--text-primary)' }} >{earning.user_id || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '100px' }} >{earning.last_msg_time || <Skeleton style={{ width: '30px' }} />}</div>

                                <Link to={`/pluto/support-chat/${earning.id}`} className="btn button-disabled" style={{ minWidth: '100px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '100px' }} onClick={() => {
                                    if (earning.id != undefined) {
                                        socket.emit('lockChatAdmin', {
                                            chat: earning.id
                                        })
                                    }
                                }}>{earning.id == undefined ? <Skeleton style={{ width: '30px' }} /> : 'Respond'}</Link>

                            </div>
                        )
                    })}
                </div>
                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                    socket.emit('getUsersAdmin', {
                        username_like: username,
                        page,
                    })
                }} />}

            </div>

        </SkeletonTheme>
    )
}

export default PlutoSupportList